var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0999 22.8C10.0999 23.4627 9.56267 24 8.89994 24H4.09997C3.1452 24 2.22953 23.6207 1.55441 22.9456C0.879283 22.2705 0.5 21.3548 0.5 20.4L0.500001 3.6C0.500002 2.64522 0.879285 1.72954 1.55441 1.05441C2.22954 0.379284 3.1452 -8.34694e-08 4.09998 0L8.89994 4.19629e-07C9.56268 4.77568e-07 10.0999 0.537258 10.0999 1.2C10.0999 1.86274 9.56268 2.4 8.89994 2.4L4.09998 2.4C3.78172 2.4 3.4765 2.52643 3.25145 2.75147C3.02641 2.97652 2.89998 3.28174 2.89998 3.6L2.89998 20.4C2.89998 20.7183 3.02641 21.0235 3.25145 21.2485C3.47649 21.4736 3.78172 21.6 4.09997 21.6L8.89994 21.6C9.56267 21.6 10.0999 22.1373 10.0999 22.8Z",
    fill: "#2A184B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4507 5.15141C16.9193 4.68278 17.6791 4.68278 18.1477 5.15141L24.1476 11.1514C24.6163 11.62 24.6163 12.3798 24.1476 12.8485L18.1477 18.8485C17.6791 19.3171 16.9193 19.3171 16.4507 18.8485C15.982 18.3798 15.982 17.62 16.4507 17.1514L21.6021 11.9999L16.4507 6.84847C15.982 6.37984 15.982 5.62004 16.4507 5.15141Z",
    fill: "#2A184B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70013 11.9999C7.70013 11.3372 8.23738 10.7999 8.90012 10.7999H23.3C23.9627 10.7999 24.5 11.3372 24.5 11.9999C24.5 12.6627 23.9627 13.1999 23.3 13.1999H8.90012C8.23738 13.1999 7.70013 12.6627 7.70013 11.9999Z",
    fill: "#2A184B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d7ba1c28.svg";
export { ForwardRef as ReactComponent };